// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import KonvoWhatsApp from '@app/features/konvo_whatsapp/state/KonvoWhatsApp';

export function handleKonvoWhatsAppUpdate(
	data: Parameters<typeof KonvoWhatsApp.applyRemote>[0],
	_context: GatewayHandlerContext,
): void {
	if (!data || typeof data !== 'object') return;
	KonvoWhatsApp.applyRemote(data);
}
